export default "__VITE_ASSET__BnO6tyEa__"